import { createContext } from 'react'

const LocationProductContext = createContext()

export default LocationProductContext
